/*
  Judge.me review lightbox: floating and draggable.

  Clicking a review in a Judge.me carousel opens `.jdgm-modal.jdgm-widget-revamp`,
  which the app builds as a blocking modal: a full-screen overlay, the page
  locked behind it. On desktop it is turned into a floating window instead —
  the page behind stays clickable and scrollable (see the matching rules in
  custom.css), and the card can be dragged anywhere on screen with the mouse.

  The card is moved with a transform on the inner `.jdgm-modal__container`,
  which holds both the card and its close button, so they travel together.
  The app re-renders the card when you step between reviews but keeps that
  container, so the position holds while browsing and resets when it opens
  again.

  Mouse only, and only above the phone breakpoint: on a phone the app shows
  the review full-screen, where there is nothing behind it to reach and a drag
  would fight the photo swipe.

  Delegated from the document because the app creates the modal on demand.
*/
(function () {
  if (window.mtJdgmLightbox) return;
  window.mtJdgmLightbox = true;

  var DESKTOP = window.matchMedia('(min-width: 750px)');
  var MARGIN = 12; // keep at least this much of the card on screen
  var drag = null;

  function frameOf(el) {
    var slide = el.closest('.jdgm-widget-revamp .jm-slide');
    return slide && slide.parentElement; // the inner .jdgm-modal__container
  }

  function offset(frame) {
    return {
      x: parseFloat(frame.dataset.mtX) || 0,
      y: parseFloat(frame.dataset.mtY) || 0,
    };
  }

  function place(frame, x, y) {
    frame.dataset.mtX = x;
    frame.dataset.mtY = y;
    frame.style.transform = 'translate(' + x + 'px, ' + y + 'px)';
  }

  document.addEventListener('pointerdown', function (event) {
    if (event.pointerType !== 'mouse' || event.button !== 0 || !DESKTOP.matches) return;
    // Controls keep their own clicks: close, arrows, thumbnails, product link.
    if (event.target.closest('button, a, input, textarea, select, [role="button"]')) return;

    var frame = frameOf(event.target);
    if (!frame) return;

    var start = offset(frame);
    var rect = frame.getBoundingClientRect();
    drag = {
      frame: frame,
      pointerId: event.pointerId,
      startX: event.clientX,
      startY: event.clientY,
      baseX: start.x,
      baseY: start.y,
      // How far the card may travel in each direction before it leaves the screen.
      minX: start.x - (rect.right - MARGIN * 4),
      maxX: start.x + (window.innerWidth - rect.left - MARGIN * 4),
      minY: start.y - rect.top + MARGIN,
      maxY: start.y + (window.innerHeight - rect.top - MARGIN * 4),
    };
    frame.classList.add('is-dragging');
    // Stops the browser dragging the photo out as an image, and text selection.
    event.preventDefault();
  });

  document.addEventListener('pointermove', function (event) {
    if (!drag || event.pointerId !== drag.pointerId) return;
    var x = drag.baseX + event.clientX - drag.startX;
    var y = drag.baseY + event.clientY - drag.startY;
    place(
      drag.frame,
      Math.min(Math.max(x, drag.minX), drag.maxX),
      Math.min(Math.max(y, drag.minY), drag.maxY)
    );
  });

  function stop(event) {
    if (!drag || event.pointerId !== drag.pointerId) return;
    drag.frame.classList.remove('is-dragging');
    drag = null;
  }

  document.addEventListener('pointerup', stop);
  document.addEventListener('pointercancel', stop);
})();
